import type { JSX, ReactNode } from 'react';
import styles from './inline-error.module.less';

type InlineErrorProps = {
  message: string;
  onRetry?: () => void;
  visible?: boolean;
  children?: ReactNode;
};

export function InlineError({
  message,
  onRetry,
  visible = true,
  children,
}: InlineErrorProps): JSX.Element | null {
  if (!visible || !message) return null;

  return (
    <div className={styles.error} role="alert">
      <span>{message}</span>
      {children}
      {onRetry && (
        <button type="button" className={styles.retry} onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
